import React, { useState, useEffect } from 'react';
import { Box, TextField, Typography } from '@mui/material';

type Props = {
  maxChars?: number;
  initialValue?: string;
  onChange?: (value: string) => void;
};

export default function CommentSection({
  maxChars = 130,
  initialValue = '',
  onChange
}: Props) {
  const [text, setText] = useState<string>(initialValue);

  useEffect(() => {
    setText(initialValue);
  }, [initialValue]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const v = e.target.value.slice(0, maxChars);
    setText(v);
    onChange?.(v);
  };

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <TextField
        placeholder="Add Comments (Optional)"
        multiline
        minRows={4}
        value={text}
        onChange={handleChange}
        variant="outlined"
        fullWidth
        inputProps={{ maxLength: maxChars }}
        sx={{
          '& .MuiOutlinedInput-root': {
            padding: 0,
            '& textarea': { padding: '16px' }
          }
        }}
      />

      <Typography
        variant="caption"
        sx={{
          position: 'absolute',
          right: 10,
          bottom: 6,
          color: 'text.secondary',
          userSelect: 'none'
        }}
      >
        {`${text.length} /${maxChars} Character limit`}
      </Typography>
    </Box>
  );
}
